import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home.js';
import MovingService from './pages/MovingService.js';
import JunkRemovalService from './pages/JunkRemovalService.js';
import Contact from './pages/Contact.js';
import Admin from './pages/Admin.js';
import './styles/App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/moving" element={<MovingService />} />
          <Route path="/junk-removal" element={<JunkRemovalService />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
